export const ProfileTypes = {
  APPLICANT: 'applicant',
  NOO: 'non_owning_occupant',
  CO_OWNER: 'co_owner',
}

export const TitleTypes = {
  TRUSTEE: 'trustee',
  NATURAL_PERSON: 'natural_person',
}

export const TitleTypeOptions = [
  { label: 'Trustee', value: TitleTypes.TRUSTEE },
  { label: 'Natural Person', value: TitleTypes.NATURAL_PERSON },
]
